<template>
  <div class="app">
    <div class="app-body">
        <div class="container-fluid">
          <router-view></router-view>
        </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'full',
  computed: {
    name () {
      return this.$route.name
    },

    list () {
      return this.$route.matched
    }
  }
}
</script>



// WEBPACK FOOTER //
// Basic.vue?7748cb70